
import Vue from 'vue';
import VxTooltip from '@/layouts/components/vx-tooltip/VxTooltip.vue';
import VxCard from '@/components/vx-card/VxCard.vue';
import VxList from '@/components/vx-list/VxList.vue';
import FeatherIcon from '@/components/FeatherIcon.vue';
import VxInputGroup from '@/components/vx-input-group/VxInputGroup.vue';
import vsInputCustom from "@/components/vsInputCustom/vsInputCustom.vue";

Vue.component(VxTooltip.name, VxTooltip);
Vue.component(VxCard.name, VxCard);
Vue.component(VxList.name, VxList);
Vue.component(FeatherIcon.name, FeatherIcon);
Vue.component(VxInputGroup.name, VxInputGroup);
Vue.component(vsInputCustom.name, vsInputCustom);

import vsDialogCustom from "@/components/vsDialogCustom/vsDialogCustom.vue";
Vue.component(vsDialogCustom.name, vsDialogCustom);

import vsDialogTabsCustom from "@/components/vsDialogCustom/vsDialogTabsCustom.vue";
import vsDialogTabCustom from "@/components/vsDialogCustom/vsDialogTabCustom.vue";
Vue.component(vsDialogTabsCustom.name, vsDialogTabsCustom);
Vue.component(vsDialogTabCustom.name, vsDialogTabCustom);

import vsRadioCustom from "@/components/vsRadioCustom/vsRadioCustom.vue";
Vue.component(vsRadioCustom.name, vsRadioCustom);

import vsCheckboxCustom from "@/components/vsCheckboxCustom/vsCheckboxCustom.vue";
Vue.component(vsCheckboxCustom.name, vsCheckboxCustom);

import vsUploadCustom from "@/components/vsUploadCustom/vsUploadCustom.vue";
Vue.component(vsUploadCustom.name, vsUploadCustom);

import autofocus from "@vuejs-tips/v-autofocus";
Vue.use(autofocus);

import VueGallery from "vue-gallery";
//Vue.use(VueGallery);
Vue.component('VueGallery', VueGallery);

// Clipboard
import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);

import bTableBusyCustom from "@/components/custom-vue-bootstrap/custom-table/custom-table-busy/bTableBusyCustom.vue";
Vue.component(bTableBusyCustom.name, bTableBusyCustom);

import vsPaginationCustom from "@/components/vsPaginationCustom/vsPaginationCustom.vue";
Vue.component(vsPaginationCustom.name, vsPaginationCustom);

import vsPaginationLengthCustom from "@/components/vsPaginationLengthCustom/vsPaginationLengthCustom.vue";
Vue.component(vsPaginationLengthCustom.name, vsPaginationLengthCustom);

import CKEditor from "@/components/ckeditor5-vue2-custom/plugin";
Vue.use(CKEditor);

import Editor from "@/components/newckeditor5/build/ckeditor.js";

Vue.prototype.$CKEditorCustom = Editor;

import CustomVueNumeric from "@/components/custom-vue-numeric";
Vue.use(CustomVueNumeric);

import ItemsProvider from "@/bvtnet-items-provider.js";
Vue.prototype.$ItemsProvider = ItemsProvider;

import VueFlatPickr from "vue-flatpickr-component";
Vue.use(VueFlatPickr);

import flatpickr from "flatpickr";
import { Portuguese } from "flatpickr/dist/l10n/pt";
flatpickr.localize(Portuguese);
flatpickr.setDefaults({
	allowInput: true,							//default false
	enableTime: false,							//default false
	enableSeconds: false,						//default false
	noCalendar: false,							//default false
	closeOnSelect: true,						//default true
	time_24hr: true,							//default false
	dateFormat: "d/m/Y",						//default Y-m-d
	locale: Portuguese,
	wrap: false,								//default false
	altInput: true,								//default false
	altFormat: "d/m/Y",							//default F j, Y
	altInputClass: "w-full flatpickr-input",	//default 'form-control input'
});

import customFlatpickrClearDatePlugin from "@/components/custom-flatpickr-limpar/index.js";
Vue.prototype.$customFlatpickrClearDatePlugin = customFlatpickrClearDatePlugin;

import * as moment from 'moment';
import 'moment/locale/pt-br';
moment.locale('en');
import VueMoment from "vue-moment";
Vue.use(VueMoment, {
	moment
});

import VueCookies from 'vue-cookies';
Vue.use(VueCookies);

import 'prismjs';

var buildEnv = '';
if (process &&
	Object.prototype.hasOwnProperty.call(process, 'env') &&
	process.env.NODE_ENV != ''
) {
	buildEnv = process.env.NODE_ENV;
}
Vue.prototype.$buildEnv = function () {
	return buildEnv;
};

// v-select component
import vSelect from "vue-select";

// Set the components prop default to return our fresh components
vSelect.props.components.default = () => ({
	Deselect: {
		render: createElement => createElement("feather-icon", {
			props: {
				icon: "XIcon",
				svgClasses: "w-4 h-4 mt-1"
			}
		}),
	},
	OpenIndicator: {
		render: createElement => createElement("feather-icon", {
			props: {
				icon: "ChevronDownIcon",
				svgClasses: "w-5 h-5"
			}
		}),
	},
});
Vue.component('v-select', vSelect);

import VueMask from "v-mask";
/*
default
#	Number (0-9)
A	Letter in any case (a-z,A-Z)
N	Number or letter (a-z,A-Z,0-9)
X	Any symbol
?	Optional (next character)
*/
Vue.use(VueMask, {
	placeholders: {
		B: /[a-z0-9]/i, 					//Controle qualidade numero lote
		//I: /^[-1-9][0-9]+$/i, 				//GLOBAL Campo tipo inteiro com negativo
		I: /[-1-9]/i, 						//GLOBAL Campo tipo inteiro com negativo
		C: /^[0-9A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ_-]*$/i, 	//Manifesto transporte numero manifesto
		U: /[a-z0-9ÃÁÀÂÇÉÊÍÕÓÔÚÜ_-]/i, 					//Controle qualidade numero lote
	},
});

Vue.use((Vue) => {
	// Assign a unique id to each component
	let uidCounter = 1;
	Vue.mixin({
		beforeCreate: function () {
			this.uidCounter = uidCounter.toString();
			uidCounter += 1;
		},
	});

	// Generate a component-scoped id
	Vue.prototype.$fid = function (id) {
		return "uid-" + this.uidCounter + "-" + id;
	};
});

import VueLodash from "vue-lodash";
import debounce from "lodash/debounce";
import delay from "lodash/delay";
import clone from "lodash/clone";
import cloneDeep from "lodash/cloneDeep";
import merge from "lodash/merge";
import once from "lodash/once";
import sortBy from "lodash/sortBy";
import remove from "lodash/remove";
import isEqual from "lodash/isEqual";
import isEqualWith from "lodash/isEqualWith";
import isFunction from "lodash/isFunction";
import camelCase from "lodash/camelCase";
Vue.use(VueLodash, {
	lodash: {
		debounce,
		delay,
		once,
		clone,
		cloneDeep,
		merge,
		isEqual,
		isEqualWith,
		isFunction,
		camelCase,
		sortBy,
		remove,
	}
});

import healthExpress from "@/healthExpress.js";
Vue.prototype.$healthExpress = healthExpress;

import * as _lodashCamelCase from "lodash/camelCase";
if (window &&
	window.FontAwesome6 &&
	window.___FONT_AWESOME6___ &&
	window.___FONT_AWESOME6___.styles
) {
	var iconTemp;
	var iconNameTemp;
	Object.keys(window.___FONT_AWESOME6___.styles).forEach((style) => {
		if (style && window.___FONT_AWESOME6___.styles[style]) {
			Object.keys(window.___FONT_AWESOME6___.styles[style]).forEach((icon) => {
				iconTemp = window.FontAwesome6.findIconDefinition({ prefix: style, iconName: icon });
				if (iconTemp && iconTemp.prefix && iconTemp.iconName) {
					if (!window.___FONT_AWESOME6___.icons) {
						window.___FONT_AWESOME6___.icons = {};
					}
					if (!window.___FONT_AWESOME6___.icons[style]) {
						window.___FONT_AWESOME6___.icons[style] = {};
					}
					if (!['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a'].includes(iconTemp.iconName)) {
						iconNameTemp = _lodashCamelCase('fa-' + iconTemp.iconName);
					} else {
						iconNameTemp = iconTemp.iconName;
					}
					//console.log('fa6', iconNameTemp);
					if (!window.___FONT_AWESOME6___.icons[style][iconNameTemp]) {
						window.___FONT_AWESOME6___.icons[style][iconNameTemp] = iconTemp;
					}
				}
			});
		}
	});
}
